import EsusView from 'components/esus/EsusView'

export default function VacinacaoView() {
  return <EsusView url='/pec/user/relatorios/producao/analiticoVacinacao' />
}
